import * as React from "react"
import { Block } from "./library/container"

export interface ButtonBlockProps {
  readonly kind: "knop"
  readonly caption: string
  readonly href: string
}

export const ButtonBlock: (props: ButtonBlockProps) => JSX.Element = p => (
  <Block>
    <div className="cta container--sg align--center">
      {/* <LinkButton route={p.href}>{p.caption}</LinkButton> Disabled because this only works for internal links at the moment */}
      <a href={p.href} className='button button--primary button--arrow'>
        <span className="button__label">{p.caption}</span>
      </a>
    </div>
  </Block>
)

{/* TH: Added to styleguide! */}
